'use client';

import type { SerializeDecimals } from 'src/services/db/prismaUtils';
import type { LoadedUser } from 'src/services/userUtils';

import { createContext, useContext } from 'react';

type SerializedLoadedUser = SerializeDecimals<LoadedUser>;

const UserContext = createContext<SerializedLoadedUser | null>(null);

export const useUser = (): SerializedLoadedUser | null => useContext(UserContext);

/**
 * Pristine passthrough provider: the context value is the `value` prop, with no
 * internal state. This lets a re-run of the server-side UserLoader (via
 * navigation or revalidation) propagate a fresh user to `useUser()` consumers.
 */
export default function UserProvider({
  value,
  children,
}: {
  value: SerializedLoadedUser | null;
  children: React.ReactNode;
}) {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
